import { Menu as MuiMenu, styled } from '@mui/material'

export const Menu = styled(MuiMenu, {
  shouldForwardProp: (prop) => prop !== 'topMenuMargin',
})<{ topMenuMargin: number }>`
  & .MuiPaper-root {
    margin-top: ${({ theme, topMenuMargin }) => theme.spacing(topMenuMargin)};
  }

  & .MuiPopover-paper {
    border: ${({ theme }) => `${theme.spacing(0.125)} solid ${theme.palette.common?.divider}`};
    border-radius: ${({ theme }) => theme.spacing(1)};
    box-shadow: none;
  }
`
